<div fxLayout>
  <main fxFlex [ngClass.lt-md]="{ mobile: true }" [ngClass]="($isMobile | async) ? 'px-2' : 'px-10'">
    <div class="grid grid-rows-[auto_auto_1fr] h-full">
      <mat-spinner *ngIf="!directEditService.site" diameter="24"></mat-spinner>

      <ng-container *ngIf="directEditService.site">
        <sbnb-direct-edit-site-header></sbnb-direct-edit-site-header>

        <mat-tab-group class="mb-8" (selectedIndexChange)="onTabChange($event)" [selectedIndex]="selectedTabIndex">
          <mat-tab *ngFor="let tab of tabs" [label]="tab.label"></mat-tab>
        </mat-tab-group>
      </ng-container>

      <section *ngIf="directEditService.error">
        <span>
          There was an error loading this site.
          <a [routerLink]="['/direct']">Return to Direct</a>
        </span>
      </section>

      <router-outlet *ngIf="directEditService.site" class="contents"></router-outlet>
    </div>
  </main>
</div>
